import React from 'react';
import DefaultLayout from 'src/Layout/Layout'
import './App.scss';

function App() {
  return (
    <div className="App">
      <DefaultLayout/>
    </div>
  );
}

export default App;
